export default {
  state: {
    eventList: [],
  }
}
